module.exports = __webpack_public_path__ + "img/question.631d0732.svg";